export default "__VITE_ASSET__24Qh9WC6__"